module.exports = __webpack_public_path__ + "img/logo-dark.13f7897e.svg";